import * as React from 'react'
import { Grid, Typography, Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import FilterTable from './FilterTable'

export default function Filters() {
  const theme = useTheme()
  return (
    <Grid container item xs={12} justifyContent='center' sx={{ marginTop: 0 }}>
      <Grid container item xs={12}>
        <Box
          sx={{
            width: '100%',
            backgroundColor: theme.palette.background.dark,
            padding: '24px',
            borderRadius: '0px',
            marginBottom: '24px',
          }}
        >
          <Box sx={{ maxWidth: '91.666667%', mx: 'auto', px: 2 }}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <Typography variant='h5' sx={{ color: 'white', fontWeight: 'bold' }}>
                  My Filters
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Grid>

      <Grid container item xs={11}>
        <FilterTable />
      </Grid>
    </Grid>
  )
}
